import AnchorNode from './AnchorNode';
import SatelliteNode from './SatelliteNode';

export const nodeTypes = {
  anchor: AnchorNode,
  satellite: SatelliteNode,
};

export { AnchorNode, SatelliteNode };
